/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{Uniform as o}from"./Uniform.js";class r extends o{constructor(o){super(o,"float")}}export{r as FloatUniform};
